<template>
  <div class="box-tbody" id="priceContainer">
    <div
      v-for="(item, index) in headInfoList"
      :key="item.poductId"
      :class="['box-tr-item', priceCarouselItemShow(index)]"
      :style="priceCarouselItemStyle(index)"
    >
      <div
        v-for="tdItem in priceHeadList"
        :key="item.poductId + tdItem.key"
        class="box-td-item"
      >
        <img
          v-if="arrDownShow(item, tdItem.key)"
          class="img-icon"
          src="../assets/home/arrow-down.png"
          alt=""
        />
        <img
          v-if="arrUpShow(item, tdItem.key)"
          class="img-icon"
          src="../assets/home/arrow-up.png"
          alt=""
        />
        {{ showTd(item, tdItem.key) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PriceTable",
  props: {
    headInfoList: {
      type: Array,
      default: () => [],
    },
    priceHeadList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      priceShowLength: 9,
      carouselPriceIndex: 1,
      setTodoFun: null,
    };
  },
  computed: {
    priceCarouseIndexList() {
      const defaultShowLenght = this.priceShowLength;
      const resList = [];

      let firDistance = this.carouselPriceIndex - 1;
      if (firDistance <= 0) {
        firDistance = firDistance + this.headInfoList.length;
      }

      resList.push(firDistance);

      for (let index = 0; index < defaultShowLenght; index++) {
        let distance = this.carouselPriceIndex + index;
        if (distance > this.headInfoList.length) {
          distance = distance - this.headInfoList.length;
        }
        if (firDistance <= 0) {
          firDistance = firDistance + this.headInfoList.length;
        }

        resList.push(distance);
      }

      let tailDistance = this.carouselPriceIndex + defaultShowLenght;
      if (tailDistance > this.headInfoList.length) {
        tailDistance = tailDistance - this.headInfoList.length;
      }
      resList.push(tailDistance);
      return resList;
    },
    priceCarouselItemStyle() {
      const defaultShowLenght = this.priceShowLength;

      const defaultItemHeight = 40;
      return (index) => {
        let currenIndex = index + 1;
        let findIndex = this.priceCarouseIndexList.findIndex(
          (item) => item === currenIndex
        );
        // if (findIndex === 0) {
        //   return {
        //     left: (findIndex - 1) * defaultItemWidth + "px",
        //   };
        // }

        // if (findIndex === this.carouseShowIndexList.length - 1) {
        //   return {
        //     left: (findIndex - 1) * defaultItemWidth + "px",
        //   };
        // }
        if (findIndex < 0) {
          return {
            top: (defaultShowLenght + 1) * defaultItemHeight + "px",
            transitionDuration: "0ms",
            // transform: `translatex(${8 * defaultItemWidth}+px)`,
          };
        }
        return {
          top: (findIndex - 1) * defaultItemHeight + "px",
          // transform: `translatex(${(findIndex - 1) * defaultItemWidth}+px)`,
        };
      };
    },
    priceCarouselItemShow() {
      return (index) => {
        let currenIndex = index + 1;
        let findIndex = this.priceCarouseIndexList.findIndex(
          (item) => item === currenIndex
        );

        if (findIndex <= 0) {
          return "carousel-hidden-item";
        }
        if (findIndex === this.priceCarouseIndexList.length - 1) {
          return "carousel-hidden-item";
        }
        return "carousel-normal-item";
      };
    },
    showTd() {
      return (item, key) => {
        return item[key];
      };
    },
    arrDownShow() {
      return (item, key) => {
        if (key !== "changePriceShow" && key !== "quoteChange") {
          return false;
        }
        let quarter = parseFloat(item[key]);
        return quarter < 0 ? true : false;
      };
    },
    arrUpShow() {
      return (item, key) => {
        if (key !== "changePriceShow" && key !== "quoteChange") {
          return false;
        }
        let quarter = parseFloat(item[key]);
        return quarter >= 0 ? true : false;
      };
    },
    arrowIcon() {
      return (item) => {
        let quarter = parseFloat(item["changePriceShow"]);
        let imgname = quarter < 0 ? "arrow-down" : "arrow-up";
        let str = `./assets/home/${imgname}.png`;
        return require(str);
      };
    },
  },
  watch: {
    // headInfoList: {
    //   handler(v){
    //     if (this.priceShowLength < v.length) {
    //       this.scrollIng();
    //       this.initHandleMouse();
    //       this.listenWindowsHidden();
    //     }
    //   },
    //   immediate: true,
    // },
  },
  mounted() {
    this.scrollIng();
    this.initHandleMouse();
    this.listenWindowsHidden();
  },
  methods: {
    listenWindowsHidden() {
      let that = this;
      document.addEventListener("visibilitychange", function () {
        let widnStatus = document.visibilityState;
        if (widnStatus === "hidden") {
          that.scrollPause();
        } else {
          that.scrollIng();
        }
      });
    },
    initHandleMouse() {
      let priceContainerDom = document.getElementById("priceContainer");
      priceContainerDom.addEventListener("mouseover", () => {
        this.scrollPause();
      });
      priceContainerDom.addEventListener("mouseout", () => {
        this.scrollIng();
      });
    },
    scrollPause() {
      if (this.setTodoFun) {
        clearInterval(this.setTodoFun);
      }
    },
    scrollIng() {
      if(this.setTodoFun){
        clearInterval(this.setTodoFun)
      }
      this.setTodoFun = setInterval(() => {
        if (this.priceShowLength >= this.headInfoList.length) {
          if (this.setTodoFun) {
            // clearInterval(this.setTodoFun);
            // this.setTodoFun = null;
            return;
          }
        }
        this.carouselPriceIndex++;
        if (this.carouselPriceIndex > this.headInfoList.length) {
          this.carouselPriceIndex = 1;
        }
      }, 1200);
    },
  },
};
</script>

<style lang="scss" scoped>
.box-tbody {
  position: relative;
  height: calc(100% - 40px);
  .box-tr-item {
    position: absolute;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #dcdfe6;
    opacity: 0;
    transition: all 1200ms linear;
    transform: translate3d(0, 0, 0);
    .box-td-item {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      line-height: 18px;
      min-width: 25%;
      width: 25%;
      padding: 0;

      font-weight: 400;
      color: #333333;
    }
  }
  .carousel-hidden-item {
    opacity: 0;
  }
  .carousel-normal-item {
    opacity: 1;
  }
}
@media (min-width: 1280px) {
  .box-tbody {
    transition: all 150ms ease-in-out;
    .box-tr-item {
      transition: all 1200ms linear;
      transition-property: top, opacity;
      transform: translate3d(0, 0, 0);
      .box-td-item {
        justify-content: flex-start;
        text-align: left;
        // padding: 0 20px;
        padding-left: 20px;
        overflow: hidden;
        line-clamp: 2;
        -webkit-line-clamp: 2;
      }
    }
  }
}
</style>